import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=06a9a79b&scoped=true&"
import script from "./Users.vue?vue&type=script&lang=ts&"
export * from "./Users.vue?vue&type=script&lang=ts&"
import style0 from "./Users.vue?vue&type=style&index=0&id=06a9a79b&lang=scss&scoped=true&"
import style1 from "./Users.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a9a79b",
  null
  
)

export default component.exports